import { HistoricalBalance } from './HistoricalBalance.entity';

export class BalanceTraceChart {
  constructor(
    public currentBalance: number,
    public averageBalance: number,
    public historical: HistoricalBalance[]
  ) {}
}
